import useAgronomicAlertsMapEntities from './useAgronomicAlertsMapEntities';

export default useAgronomicAlertsMapEntities;
